import { orderCatalogue } from "./catalogue-order";
import { certificationOf } from "./app-certification";
function fromCatalogue(a, certified) {
    var _a, _b, _c, _d, _e, _f;
    return {
        id: `cat-${a.id}`,
        name: a.name,
        color: a.color,
        text: a.text,
        wordmark: a.wordmark,
        letter: a.letter,
        tag: a.tag || undefined,
        logoUrl: (_a = a.logoUrl) !== null && _a !== void 0 ? _a : undefined,
        androidSlug: (_b = a.androidSlug) !== null && _b !== void 0 ? _b : undefined,
        tizenId: (_c = a.tizenId) !== null && _c !== void 0 ? _c : undefined,
        webosId: (_d = a.webosId) !== null && _d !== void 0 ? _d : undefined,
        iosScheme: (_e = a.iosScheme) !== null && _e !== void 0 ? _e : undefined,
        webUrl: (_f = a.webUrl) !== null && _f !== void 0 ? _f : undefined,
        ...(certified ? { certified: true } : {}),
    };
}
export function withGlobalApps(global, disabledIds = [], order, isCare = false) {
    const list = Array.isArray(global) ? global : [];
    const off = new Set(Array.isArray(disabledIds) ? disabledIds : []);
    const shown = orderCatalogue(list, order)
        .filter((a) => !off.has(a.id))
        .filter((a) => !isCare || certificationOf(a) === null);
    const certified = new Set(shown.filter((a) => certificationOf(a) !== null).map((a) => a.id));
    if (certified.size === 0)
        return shown.map((a) => fromCatalogue(a, false));
    return [
        ...shown.filter((a) => certified.has(a.id)),
        ...shown.filter((a) => !certified.has(a.id)),
    ].map((a) => fromCatalogue(a, certified.has(a.id)));
}
export function hasCertifiedApp(apps) {
    return Array.isArray(apps) && apps.some((a) => a.certified === true);
}
export function certifiedEnabledIds(global, disabledIds, isCare = false) {
    const off = new Set(Array.isArray(disabledIds) ? disabledIds : []);
    const out = new Set();
    if (isCare)
        return out;
    for (const a of Array.isArray(global) ? global : []) {
        if (certificationOf(a) !== null && !off.has(a.id))
            out.add(a.id);
    }
    return out;
}
export function careForbiddenAppIds(global) {
    const out = new Set();
    for (const a of Array.isArray(global) ? global : []) {
        if (certificationOf(a) !== null)
            out.add(a.id);
    }
    return out;
}
